'use client';

import styles from '../not-found.module.scss';
import cx from 'classnames';
import {
  CatButton,
  CatHeading,
  CatIconChevronLeft
} from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { isExternalReferrer } from '@cat-ecom/common/utils/browserUtils';

export interface SectionHeadingProps {
  title: string;
  text: string;
  main?: boolean;
  dealerUrl?: string;
}

export default function SectionHeading({
  title,
  text,
  main = false,
  dealerUrl
}: Readonly<SectionHeadingProps>) {
  const t = useTranslations();
  const { back } = useRouter();
  const titleVariant = main ? 'headline' : 'title';
  const hideBackButton = isExternalReferrer(
    document.referrer,
    document.location.host
  );

  return (
    <div className={cx('d-flex flex-column')}>
      <CatHeading variant={titleVariant} className={styles['capitalize-first']}>
        {t(title)}
      </CatHeading>
      <p className="cat-u-theme-typography-body mb-0 pt-3">{t(text)}</p>
      {main && (
        <div
          className={cx(
            styles['not-found__container__heading-buttons-container'],
            'pt-3'
          )}
        >
          {!hideBackButton && (
            <CatButton variant="contrast" onClick={() => back()}>
              {t('SUBMIT_BACK')} <CatIconChevronLeft slot="before" />
            </CatButton>
          )}
          <CatButton
            expanded
            variant="primary"
            href={dealerUrl}
            data-testid="go-to-parts"
          >
            <p className={cx('mb-0', styles['capitalize-first'])}>
              {t('GO_TO_PARTS')}
            </p>
          </CatButton>
        </div>
      )}
    </div>
  );
}
